import React from 'react';
import styles from './style.module.css';
import StepThreeForm from '../../components/forms/step-three';

export default () => (
    <div className={styles.page}>
        <p className={styles.topTitle}>My Prosperity Planner</p>
        <h1 className={styles.mainTitle}>Must Do and Love To</h1>
        <p className={styles.text}>While prosperity isn't all about money, money influences financial priorities and inspires possibilities, especially when matched with a plan. What does prosperity mean to you?</p>
        <p className={styles.text}>We recommend selecting <strong>3&nbsp;MUST&nbsp;DO</strong> and <strong>3&nbsp;LOVE&nbsp;TO</strong> options to best start your Libro coaching conversation.</p>
        <StepThreeForm/>
    </div>
);
